<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Eyou_Username')" prop="username">
      <el-input
        v-model="model.params.username"
        :placeholder="$t('ChannelConfig_Eyou_Username_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Eyou_Password')" prop="password">
      <el-input
        v-model="model.params.password"
        :placeholder="$t('ChannelConfig_Eyou_Password_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Eyou_ApiToken')" prop="apiToken">
      <el-input
        v-model="model.params.apiToken"
        :placeholder="$t('ChannelConfig_Eyou_ApiToken_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'eyou')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Eyou.vue